import React, { useEffect, useState } from 'react';
import { Target, Cpu, Users } from 'lucide-react';
import appDataService, { Club } from '../services/appDataService';
import ListingExplorer, {
  ListingFilterDef,
  ListingBadge,
  ListingItem,
} from '../components/listings/ListingExplorer';

const FILTERS: ListingFilterDef[] = [
  { key: 'steeldart', label: 'Steeldart', icon: Target, test: (i) => (i as Club).steeldart === true },
  { key: 'edart', label: 'E-Dart', icon: Cpu, test: (i) => (i as Club).edart === true },
];

const badgesFor = (item: ListingItem): ListingBadge[] => {
  const club = item as Club;
  const badges: ListingBadge[] = [];
  if (club.steeldart) badges.push({ key: 'steel', label: 'Steeldart', icon: Target });
  if (club.edart) badges.push({ key: 'edart', label: 'E-Dart', icon: Cpu });
  return badges;
};

const ClubsPage: React.FC = () => {
  const [clubs, setClubs] = useState<Club[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    appDataService
      .getClubs()
      .then((data) => {
        if (!cancelled) setClubs(Array.isArray(data) ? data : []);
      })
      .catch(() => {
        if (!cancelled) setClubs([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <ListingExplorer
      items={clubs}
      loading={loading}
      title="Dart-Vereine"
      subtitle="Finde deinen Verein: Trainiere, spiele Liga und werde Teil der Dart-Community in deiner Nähe."
      searchPlaceholder="Verein oder Ort suchen..."
      countLabel="Vereine"
      countLabelSingular="Verein"
      emptyIcon={Users}
      fallbackIcon={Users}
      emptyLabel="Keine Vereine gefunden"
      routeBase="/verein"
      filters={FILTERS}
      badges={badgesFor}
      seoTitle="Dart-Vereine & Clubs | DartCloud"
      seoDescription="Finde Dart-Vereine und Clubs in deiner Nähe auf DartCloud – mit Steeldart und E-Dart."
    />
  );
};

export default ClubsPage;
